export const ADD_TEAMS_DATA = 'ADD_TEAMS_DATA';
export const RESET_TEAMS_DATA = 'RESET_TEAMS_DATA';

const INITIAL_STATE = {
  teams: [],
  isLoaded: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_TEAMS_DATA:
      return {
        teams: action.payload,
        isLoaded: true,
      };
    case RESET_TEAMS_DATA:
      return {
        teams: action.payload,
        isLoaded: false,
      };
    default:
      return state;
  }
}

export function addTeamsData(teams) {
  return { type: ADD_TEAMS_DATA, payload: teams };
}

export function resetTeamsData() {
  return { type: RESET_TEAMS_DATA, payload: [] };
}
